//Contact.js
import React from 'react'
import { Text, View, Linking } from 'react-native'
import styles from './Styles.js'

//const border = 0;

const Contact = () => {
  return (
    <View>
      <Text style={styles.titleTextBlack}>Contact us to learn more.</Text>
      <View style={{borderWidth: border, width: 380}}>
        <Text
          style={styles.linkBlackBig}
          onPress={
            () => Linking.openURL('mailto:marcioseno@hotmail.com')
          }
        >
          Email: marcioseno@hotmail.com
        </Text>
      </View>
      <View style={{borderWidth: border, width: 350}}>
        <Text
          style={styles.linkBlackBig}
          onPress={
            () => Linking.openURL('http://bit.ly/3hVEwlY')
          }
        >
          WhatsApp: +55 11 99902-9313
        </Text>
      </View>
      <View style={{borderWidth: border, width: 310}}>
        <Text
          style={styles.linkBlackBig}
          onPress={
            () => Linking.openURL('tel:${+5511999029313}')
          }
        >
          Phone: +55 11 99902-9313
        </Text>
      </View>
      <Text> </Text>
      <Text> </Text>
    </View>
  )
};
export default Contact;
